import { Card, CardContent } from './ui/card';
import { motion } from 'framer-motion';
import { FileText, Shield, ShoppingCart } from 'lucide-react';

interface LegalPageProps {
  t: any,
  title: string;
  type: 'warranty' | 'purchase' | 'privacy';
  language: string;
}

export default function LegalPage({ t, title, type }: LegalPageProps) {
  const getIcon = () => {
    switch (type) {
      case 'warranty': return Shield;
      case 'purchase': return ShoppingCart;
      case 'privacy': return FileText;
      default: return FileText;
    }
  };

  const getContent = () => {
    switch (type) {
      case 'warranty':
        return {
          sections: [
            {
              content: t.warrantyTermsContent
            },
          ]
        };
      case 'purchase':
        return {
          sections: [
            {
              content: t.purchaseAgreementContent
            },
          ]
        };
      case 'privacy':
        return {
          sections: [
            {
              content: t.privacyContent
            }
          ]
        };
      default:
        return { sections: [] };
    }
  };

  const Icon = getIcon();
  const content = getContent();

  return (
    <div className="min-h-screen">
      <section className="py-20 bg-gradient-to-b from-[#1A1A1A] to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-12"
          >
            <div className="bg-emerald-800 rounded-full w-20 h-20 mx-auto mb-6 flex items-center justify-center">
              <Icon className="h-10 w-10 text-white" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-emerald-600 mb-8">
              {title}
            </h1>
          </motion.div>

          <div className="space-y-8">
            {content.sections.map((section, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
              >
                <Card className="bg-gray-800 border-gray-700">
                  <CardContent className="p-8">
                    {/* <h2 className="text-2xl font-bold text-emerald-600 mb-4">{section.title}</h2> */}
                    <p className="text-gray-300 leading-relaxed" dangerouslySetInnerHTML={{ __html: section.content }}/>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}